import { SentryModule } from './sentry.module';
export { SentryModule };

export const SENTRY_MODULE_CONFIG = 'SENTRY_MODULE_CONFIG';
